exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Toastify__toast {\n  color: rgba(34, 34, 34, .70);\n  padding-left: 24px;\n}\n\n.Toastify__close-button {\n  -ms-flex-item-align: center;\n      align-self: center;\n  margin-right: 10px;\n}\n\n.Toastify__progress-bar {\n  background: #8c9fed;\n}\n", ""]);

// exports
